'use client'

import styled from "styled-components";
import Form from "@/components/UI/Form/Form/Form";
import {getColor} from "@/pipes/theme.pipe";
import PasswordInput from "@/components/UI/Form/Inputs/PasswordInput/PasswordInput";
import PhoneInput from "@/components/UI/Form/Inputs/PhoneInput/PhoneInput";
import Button from "@/components/UI/Button/Button";
import Title from "@/components/UI/Title/Title";
import Description from "@/components/UI/Description/Description";
import Submit from "@/components/UI/Form/Submit/Submit";

export const SignUpWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    flex: 1;
    gap: 28px;
`

export const SignupTitleDescWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: fit-content;
`

export const SignUpTitle = styled(Title).attrs({
    size: 'lg'
})`
    font-size: clamp(20px, 4vw, 36px);
`

export const SignUpDescription = styled(Title).attrs({
    size: 'sm:subtitle'
})``

export const SignUpForm = styled(Form)`
    display: flex;
    flex-direction: column;
    gap: clamp(15px, 2vw, 30px);
    width: 100%;
`

export const SignUpPhoneInput = styled(PhoneInput)``

export const SignUpPasswordInput = styled(PasswordInput)``

export const Text = styled(Description).attrs({
    size: 'sm'
})`
    a {
        padding: 0;
    }
`

export const NextButton = styled(Submit).attrs({
    size: 'lg',
    color: 'secondaryDark',
})`
    font-size: 14px;
    max-width: 113px;
    align-self: center;
`

export const SignInButton = styled(Button).attrs({
    variant: 'link',
    href: 'signin'
})`
    text-decoration: underline;
    font-weight: 600;
    color: ${getColor('primary', '500')} !important;
`